import { WcgTableValues } from '@shared/interfaces/wcg-table-utils.interface';
import { ActivatedRouteSnapshot } from '@angular/router';

export type DColumnType = 'icon' | 'text' | 'link' | 'chip' | 'default';
export type DColumns = {
  label: string;
  key: string;
  type: DColumnType;
  blankHeader: boolean;
};

export type OperationStatus =
  | 'idle'
  | 'initiated'
  | 'in-progress'
  | 'success'
  | 'failure';

export type DownloadBody = {
  study_id: string;
  entity_id: string;
  entity_type: string;
  is_outcome: boolean;
};

export type DownloadRequest = DownloadBody & {
  ids: string[];
};

export type ExportArgs = Record<string, string | number | boolean>;

export type ExportRequest = {
  url: string;
  wcgTableValues: WcgTableValues;
  args?: ExportArgs;
};

export type ResponseStatus = Array<{
  label: string;
  value: string;
}>;

export interface DocumentDownloadParams {
  page: number;
  pageSize: number;
  category: string;
}

export type FileOperationState = {
  status: OperationStatus | undefined;
  fileName: string | undefined;
  errorMessage: string | undefined;
  isDialogOpen: boolean;
};
export type DocumentDownloadResponse = {
  data: DocumentDownload[];
  status: ResponseStatus;
  total: number;
};

export type DocumentDownload = {
  id: string;
  file_name: string;
  status: string;
  created_dt: string;
  updated_dt: string;
  sponsor_name: string;
  sponsor_protocol_id: string;
  investigator_name: string;
};

export type DocumentExportResponse = {
  data: DocumentExport[];
  status: ResponseStatus;
  total: number;
};

export type DocumentExport = {
  id: string;
  file_name: string;
  study_id?: string;
  entity_id?: string;
  entity_type?: string;
  status: string;
  created_dt: string;
  updated_dt: string;
  category: string;
  expiry_dt: string;
  wcg_tracking_id?: string;
  details?: string;
  sponsor_protocol_id?: string;
  sponsor_name?: string;
  workspace_int_id?: number;
  investigator_name?: string;
};
export type DocumentLinkResponse = {
  link: string;
};

export type DownloadState = FileOperationState & {
  downloadsData: DocumentDownloadResponse | undefined;
};
export type ExportState = FileOperationState & {
  exportsData: DocumentExportResponse | undefined;
};

export const CONFIGURE_DEFAULT_PARAMS = (
  route?: ActivatedRouteSnapshot,
): WcgTableValues => {
  return {
    page: route?.queryParams?.['pageIndex'] ?? 1,
    pageSize: route?.queryParams?.['pageSize'] ?? 10,
  };
};

export type FileStatusInfo = {
  fileName: string;
  status: OperationStatus;
  fileStage?: string | undefined;
};

export type FileStatusFailed = FileStatusInfo & {
  errorMessage: string;
};
